@if (isExpireContract === true) {
<div class="container">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <div class="grid">
    <div class="col-12 client-data-apply_margin_bottom">
      <span class="client-data-title">Resumo do(s) Plano(s)</span>
    </div>
  </div>
  <div class="payment-content-shell">
    <div class="payment-content">
      <div class="p-fluid fluid">
        <fieldset legend="Solicitação de Reativação do Link de Pagamento">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-12 lg:col-12" style="margin-bottom: 2%;">
              <span class="filtro">
                Prezado cliente,<br>
                O link de pagamento está expirado. Para solicitar a reativação do link, por favor, clique no
                botão: “Solicitar” abaixo. <br>
                Sua solicitação será analisada pelo departamento responsável e, em seguida, você receberá as
                instruções para prosseguir com o pagamento.
              </span>
            </div>
            <div class="col-12" style="text-align: right; margin-top: 0; margin-bottom: 2%;">
              <button pButton class="ui-button btn-next" [disabled]="isSubmitted" [attr.aria-busy]="isSubmitted"
                [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : ''" type="button" (click)="reactivateContract()">
                {{ isSubmitted ? 'Solicitando' : 'Solicitar' }}
              </button>
            </div>
          </div>
        </fieldset>
        @if (isBlockedExpireContract === true) {
        <fieldset legend="Solicitar a Reativação de Contrato Para o Pagamento">
          <div class="grid ui-fluid">
            <div class="col-12 md:col-12 lg:col-12">
              <span class="filtro">Solicitação realizada com sucesso.</span><br />
            </div>
          </div>
        </fieldset>
        }
      </div>
    </div>
  </div>
</div>
}

@if (isExpireContract === false) {
<div class="contract-summary">
  @if (blockedUi) {
  <div class="fp-block-ui-overlay" aria-live="polite" aria-busy="true">
    <i class="pi pi-spin pi-spinner" style="font-size: 60px;font-weight: bold"></i>
  </div>
  }
  <div class="grid">
    <div class="col-12 client-data-apply_margin_bottom">
      <span class="client-data-title">Resumo do(s) Plano(s)</span>
    </div>
  </div>
  <div class="payment-content-shell">
    <div class="payment-content">
      <div class="p-fluid fluid">
        <fieldset>
          <table style="width: 100%;" border="0px" class="summary-data-table">
            <tr>
              <td colspan="2">
                <span class="client-data-field-name">Dados do Veículo</span>
              </td>
            </tr>
            <tr>
              <td>
                <span class="summary-label">Modelo:</span>
                <span class="summary-value">{{ paymentContractSummaryShort.vehicleLine }}</span>
              </td>
              <td>
                <span class="summary-label">Ano Modelo:</span>
                <span class="summary-value">{{ paymentContractSummaryShort.modelYear }}</span>
              </td>
              <td>
                <span class="summary-label">Início Garantia:</span>
                <span class="summary-value">{{ paymentContractSummaryShort.cvvg | date: 'dd/MM/yyyy':'UTC'}}</span>
              </td>
              <td>
                <span class="summary-label">Odômetro:</span>
                <span class="summary-value">{{ paymentContractSummaryShort.odometerStart }}</span>
              </td>
              <td rowspan="2">
                <img style="width: 100px; height: 50px;" src="../../../assets/image/vin/car.png" alt="">
              </td>
            </tr>
          </table>
        </fieldset>
        <br />
        <fieldset>
          <table style="width: 100%;" border="0px">
            <tr>
              <td colspan="4">
                <span class="client-data-field-name">Resumo do Contrato</span>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <br />
                <span class="client-data-field-sub-name">Já Incluso</span>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <span>{{ paymentContractSummaryShort.factoryTimeLimit }} meses de garantia </span>
                @if (paymentContractSummaryShort.factoryDistanceLimit === 999999) {
                <span>(Km
                  ilimitado)</span>
                }
                @if (paymentContractSummaryShort.factoryDistanceLimit !== 999999) {
                <span>{{
                  paymentContractSummaryShort.factoryDistanceLimit }} Km de garantia</span>
                }
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <span>Ford Assistance - 1 ano de assistência 24 horas</span>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <br />
                <span class="client-data-field-sub-name">Contratado</span>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ paymentContractSummaryShort.extension?.productName }}</span>
              </td>
              <td>
                @if (paymentContractSummaryShort.extension?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.extension?.term }} Meses</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.extension?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.extension?.distance }} Km</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.extension?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.extension?.customerPrice | currency:'BRL' }}</span>
                }
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ paymentContractSummaryShort.maintenance?.productName }}</span>
              </td>
              <td>
                @if (paymentContractSummaryShort.maintenance?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.maintenance?.term }} Meses</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.maintenance?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.maintenance?.distance }} Km</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.maintenance?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.maintenance?.customerPrice | currency:'BRL' }}</span>
                }
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ paymentContractSummaryShort.part?.productName }}</span>
              </td>
              <td>
                @if (paymentContractSummaryShort.part?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.part?.term }} Meses</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.part?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.part?.distance }} Km</span>
                }
              </td>
              <td>
                @if (paymentContractSummaryShort.part?.customerPrice > 0) {
                <span>{{
                  paymentContractSummaryShort.part?.customerPrice | currency:'BRL' }}</span>
                }
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <hr class="margin-top-5" />
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="float: right;">
                <span class="client-data-field-sub-name">Total:</span>
              </td>
              <td>
                <span class="client-data-field-sub-name">{{ paymentContractSummaryShort?.total |
                  currency:'BRL' }}</span>
              </td>
            </tr>
          </table>
        </fieldset>
        <br />
        @if (isValidationPayment === false) {
        <fieldset>
          <div class="card">
            <p-tabView>
              <p-tabPanel header="Cartão de Crédito">
                <table style="width: 100%;" border="0px">
                  <tr>
                    <td>
                      <label class="filtro" for="cardNumberPg">Número do Cartão:</label><br />
                      <p-inputMask id="cardNumberPg" [(ngModel)]="paymentMethod.cardNumber" mask="9999 9999 9999 9999"
                        (change)="onPaymentFieldChange()"></p-inputMask>
                    </td>
                    <td>
                      <label class="filtro" for="validateMonthPg">Mês da Validade:</label><br />
                      <p-dropdown id="validateMonthPg" [(ngModel)]="validateMonth" [options]="monthCard"
                        optionLabel="label" [style]="{'minWidth':'100%'}"
                        (change)="onPaymentFieldChange()"></p-dropdown>
                    </td>
                    <td>
                      <label class="filtro" for="validateYearPg">Ano da Validade:</label><br />
                      <p-dropdown id="validateYearPg" [(ngModel)]="validateYear" [options]="yearCard"
                        optionLabel="label" [style]="{'minWidth':'100%'}"
                        (change)="onPaymentFieldChange()"></p-dropdown>
                    </td>
                    <td>
                      <label class="filtro" for="cvvPg">CVV:</label><br />
                      <p-inputMask id="cvvPg" [(ngModel)]="paymentMethod.cardSecurityCode" mask="999"
                        (change)="onPaymentFieldChange()"></p-inputMask>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label class="filtro" for="cardNamePg">Nome Impresso no Cartão:</label><br />
                      <input id="cardNamePg" pInputText [(ngModel)]="paymentMethod.cardName" maxlength="30" type="text"
                        style="width: 100%" (input)="filterInput($event)" (change)="onPaymentFieldChange()" />
                    </td>
                    <td>
                      <label class="filtro" for="cpfPg">CPF:</label><br />
                      <p-inputMask id="cpfPg" [(ngModel)]="paymentMethod.cardDocument" mask="999.999.999-99"
                        (change)="onPaymentFieldChange()"></p-inputMask>
                    </td>
                    <td>
                      <label class="filtro" for="installmentsPg">Parcelas:</label><br />
                      <p-dropdown id="installmentsPg" [(ngModel)]="portion" [options]="portionCard"
                        (onChange)="portionCalculate()" (change)="onPaymentFieldChange()"
                        [style]="{'minWidth':'100%'}"></p-dropdown>
                    </td>
                    <td>
                      <label class="filtro" for="installmentsValuePg">Valor da Parcelas:</label><br />
                      <p-inputNumber id="installmentsValuePg" [disabled]="true" [(ngModel)]="portionTotal" mode="currency"
                        currency="BRL" locale="pt-BR" [style]="{'width':'100%'}"></p-inputNumber>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4" style="text-align: right;">
                      <app-cta-button [label]="'TRANSLATE.FINISH_PURCHASE'"
                        [loadingLabel]="'TRANSLATE.FINISHING_PURCHASE'" [successState]="isCtaSuccess"
                        [disabled]="isSubmitted" [loading]="isSubmitted" [icon]="'pi-id-card'"
                        (buttonClick)="contractPayment()">
                      </app-cta-button>
                    </td>
                  </tr>
                </table>
              </p-tabPanel>
              <p-tabPanel header="Boleto">
                <div class="col-12">
                  <p-panel>
                    <div class="grid ui-fluid">
                      <div class="col-12 md:col-6 lg:col-4">
                        <span class="filtro">Data do Vencimento:</span><br />
                        @if (!isHasBoleto) {
                        <p-calendar [(ngModel)]="createBoletoRequestDto.dueDate" [readonlyInput]="true"
                          [maxDate]="maxDatePermitted" [minDate]="minDatePermitted" dateFormat="yy-mm-dd"></p-calendar>
                        }
                        @if (isHasBoleto) {
                        <p-calendar [(ngModel)]="dueDate" [disabled]="true" dateFormat="yy-mm-dd"></p-calendar>
                        }
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <br>
                        <button pButton
                          [disabled]="isSubmitted || isSubmittedDownload || !createBoletoRequestDto.dueDate || isHasBoleto"
                          [attr.aria-busy]="isSubmitted" [icon]="isSubmitted ? 'pi pi-spin pi-spinner' : 'pi pi-book'"
                          type="button" (click)="saveBoletoContract()" class="btn-pattern">
                          {{ isSubmitted ? 'Gerando Boleto....' : labelGerarBoleto }}
                        </button>
                      </div>
                      <div class="col-12 md:col-6 lg:col-4">
                        <br>
                        <button pButton [disabled]="isSubmittedDownload || isSubmitted || !isHasBoleto"
                          [attr.aria-busy]="isSubmittedDownload"
                          [icon]="isSubmittedDownload ? 'pi pi-spin pi-spinner' : 'pi pi-download'" type="button"
                          (click)="downloadBoletoSaPayments()" class="btn-pattern">
                          {{ isSubmittedDownload ? 'Baixando PDF....' : 'Baixar PDF' }}
                        </button>
                      </div>
                      @if (isHasBoleto) {
                      <div class="col-12 md:col-6 lg:col-8">
                        <label class="filtro" for="barCode">Código de Barras</label><br />
                        <input id="barCode" pInputText [(ngModel)]="barcode" maxlength="30" type="text"
                          style="width: 100%" [disabled]="true" />
                      </div>
                      }
                      @if (isHasBoleto) {
                      <div class="col-12 md:col-6 lg:col-4">
                        <br>
                        <button pButton icon="pi pi-copy" type="button" (click)="copyBarcodeToClipboard()"
                          class="btn-pattern">
                          {{ 'TRANSLATE.COPY.CODE' | translate }}
                        </button>
                      </div>
                      }
                    </div>
                  </p-panel>
                </div>
              </p-tabPanel>
            </p-tabView>
          </div>
        </fieldset>
        }
        @if (isValidationPayment === true) {
        <fieldset>
          @if (paymentContractSummaryShort.maintenance !== undefined) {
          <div class="grid">
            <div class="col-12">
              <h3>Pagamento realizado com sucesso.</h3>
            </div>
          </div>
          }
          @if (paymentContractSummaryShort.maintenance === undefined) {
          <table style="width: 100%;" border="0px">
            <tr>
              <td colspan="4">
                <span class="client-data-field-name">Formas de Pagamento - Cartão de Crédito</span>
                <br />
                <br />
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <span class="filtro">{{ paymentMethodRequest.message }}</span><br />
              </td>
            </tr>
          </table>
          }
        </fieldset>
        }
        <table style="width:100%; height:100%">
          @if (isValidationPayment === false) {
          <tr>
            @if (isToShowBackButton === true) {
            <td align="justify" width="100%">
              <div class="grid">
                <div class="col-12" style="text-align: right; margin-top:2%; margin-bottom: 2%">
                  <button pButton class="ui-button btn-back" (click)="buttonComeBack()" type="button"
                    label="{{'TRANSLATE.RETURN' | translate }}" id="btnStatusPayment">{{ 'TRANSLATE.RETURN' | translate
                    }}</button>
                </div>
              </div>
            </td>
            }
          </tr>
          }
        </table>
      </div>
    </div>
  </div>
</div>
}